// extracted by mini-css-extract-plugin
module.exports = {"Subtitle":"Subtitle_Subtitle__2jyWX","Avatar":"Subtitle_Avatar__rLuBm"};